<template>
  <v-alert
    v-if="getSetting('cookie_consent_enabled')"
    type="info"
  >
    <rich-text-content
      :data="getSetting('cookie_consent_message')"
    />
  </v-alert>
</template>

<script setup lang="ts">
import RichTextContent from '@/components/rich-text/RichTextContent.vue';
import { useSettings } from '@/composables';

const { getSetting } = useSettings();
</script>
